import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { CareType } from 'src/constants/CareTypes';
import {
    CareTypeFeatures,
    DisabledCareTypeFeatures,
    selectCareTypeFeatures,
} from 'src/store/careTypeFeatures';

/**
 * Single entry point for "is X enabled for this care type?" questions.
 * Resolves EHR, check-in, observation and Gen3 config for a care type (usually `unit.careType`).
 */
function useCareTypeFeatures() {
    const featuresByCareType = useSelector(selectCareTypeFeatures);

    const getFeatures = useCallback(
        (careType?: CareType | string | null): CareTypeFeatures =>
            (careType && featuresByCareType[careType as CareType]) || DisabledCareTypeFeatures,
        [featuresByCareType]
    );

    return { featuresByCareType, getFeatures };
}

export default useCareTypeFeatures;
